import React from 'react'
import FlexRow from '../FlexRow'
import FlexColumn from '../FlexColumn'
import Button from '../Button'
import Text from '../Text'

export default function TabBar({ tabs, value, onChange, styleProps, ...props }) {
  return (
    <FlexRow alignItems="center" color={styleProps?.color || 'background.0'} {...props}>
      {tabs.map((tab, index) => {
        const isLast = index === tabs.length - 1

        return (
          <FlexColumn
            key={tab.label}
            mr={isLast ? null : 'small'}
            borderBottom={tab.value === value ? 'solid' : null}
            borderColor={styleProps?.borderColor || 'background.0'}
            height="100%"
          >
            <Button
              kind="basic-transparent"
              height="100%"
              shape="block"
              onPress={() => onChange(tab)}
              color="inherit"
            >
              <Text
                color={tab.value === value ? (styleProps?.borderColor || 'background.0') : "inherit"}
              >
                {tab.label}
              </Text>
            </Button>
          </FlexColumn>
        )
      })}
    </FlexRow>
  )
}
